/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CancelSubscriptionApiArg, CancelSubscriptionResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    cancelSubscription: build.mutation<CancelSubscriptionResponse, CancelSubscriptionApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/billing/subscription/cancel`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as cancelSubscriptionApi };
export const { useCancelSubscriptionMutation } = injectedRtkApi;
